import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IAreaTypeData } from "../AreaTypes.types";

export const useAddAreaTypeViewModel = ({
  goBack = () => null,
  reset = () => null,
}: IUseAddAreaTypeViewModelProps = {}) => {
  const stateManager = useComponentState();
  const [areaTypeDetails, setAreaTypeDetails] = useState<IAreaTypeData>(
    {} as IAreaTypeData
  ); // area type details used as a source of comparison for Preview tab

  const fetchAreaTypeDetails = async (id: string) => {
    const response = await stateManager.run(() =>
      homeService.areaTypes.get({ id })
    );
    if (response.status === HTTP_STATUSES.OK) {
      reset(response.data);
      setAreaTypeDetails(response.data);
    }
  };

  const handleCreateAreaType = async (data: IAreaTypeData) => {
    const response = await stateManager.run(() =>
      homeService.areaTypes.create({
        data,
        toastMessageConfig: {
          success: { text: `Successfully created Area: ${data.name}.` },
        },
      })
    );
    if (response.status === HTTP_STATUSES.OK) {
      goBack();
    }
  };

  const handleUpdateAreaType = async (data: IAreaTypeData) => {
    const response = await stateManager.run(() =>
      homeService.areaTypes.update({
        id: data.id,
        data,
        modifiedOn: data.modifiedOn,
        toastMessageConfig: {
          success: { text: `Successfully updated Area: ${data.name}.` },
        },
      })
    );
    if (response.status === HTTP_STATUSES.OK) {
      goBack();
    }
  };

  return {
    isLoading: stateManager.isBusy(),
    areaTypeDetails,
    fetchAreaTypeDetails,
    handleCreateAreaType,
    handleUpdateAreaType,
  };
};

interface IUseAddAreaTypeViewModelProps {
  goBack?: () => void;
  reset?: (data: IAreaTypeData) => void;
}
